import { DeliveryFeesType } from "@/types/business/delivery.type";
import { DeliveryFeesInterface } from "@/interface/business/delivery.interface";
import { StorageConstants } from "@/enums/storage.enum";
import Storage from "@/services/storage";

export default class DeliveryFees implements DeliveryFeesInterface {
  id: string;
  area_id: string;
  cost: number;
  created_at: string;
  updated_at: string;
  isAuto: boolean = false;

  constructor(data: DeliveryFeesType) {
    this.id = data.id;
    this.area_id = data.area_id;
    this.cost = data.cost;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.isAuto = data.cost > 0;
  }

  public getCostValue(): string {
    const currency = Storage.get(StorageConstants.BUSINESS).currency || "";
    let cost = this.cost || 0;
    if (!!cost) {
      cost = cost / 1000;
    }

    return `${cost.toFixed(3)} ${currency}`;
  }
}
